/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


import { ofType } from 'redux-observable';
import { debounceTime, mergeMap, Observable } from 'rxjs';
import { IAction } from 'src/js/actions/IshAction';
import { getCheckoutModelFromBackend } from 'src/js/enrol/actions/Actions';
import { REPLACE_ITEM, UPDATE_ITEM } from 'src/js/enrol/containers/summary/actions/Actions';


export const EpicSyncCheckoutModel = (action$: Observable<IAction>): any => {
  return action$.pipe(
    ofType(
      REPLACE_ITEM,
      UPDATE_ITEM
    ),
    debounceTime(200),
    mergeMap(() => [
      getCheckoutModelFromBackend()
    ])
  );
};